import { render, staticRenderFns } from "./school-fonts.vue?vue&type=template&id=5898a581&scoped=true"
import script from "./school-fonts.vue?vue&type=script&lang=js"
export * from "./school-fonts.vue?vue&type=script&lang=js"
import style0 from "./school-fonts.vue?vue&type=style&index=0&id=5898a581&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5898a581",
  null
  
)

export default component.exports